<template>
  <!-- 销售网点的修改页面 -->
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="800"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="网点名称"
        >
          <a-input
            :disabled="disabled"
            placeholder="请输入网点名称"
            :max-length="16"
            v-decorator="['name']"
            >{{ name }}</a-input
          >
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="官网网址"
        >
          <!-- <div style="margin-bottom: 16px">
            <a-input v-decorator="['web', validatorRules.web]">
              <a-select
                slot="addonBefore"
                :value="beforeValue"
                style="width: 90px"
                @change="addBeforeChange"
              >
                <a-select-option value="http://">
                  http://
                </a-select-option>
                <a-select-option value="https://">
                  https://
                </a-select-option>
              </a-select>
              <a-select
                slot="addonAfter"
                :value="afterValue"
                style="width: 80px"
              >
                <a-select-option value=".com">
                  .com
                </a-select-option>
                <a-select-option value=".jp">
                  .jp
                </a-select-option>
                <a-select-option value=".cn">
                  .cn
                </a-select-option>
                <a-select-option value=".org">
                  .org
                </a-select-option>
              </a-select>
            </a-input>
          </div> -->
          <a-input
            placeholder="请输入官网网址"
            :max-length="30"
            v-decorator="['web', validatorRules.web]"
          />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="客服电话"
        >
          <a-input
            placeholder="请输入网点电话"
            :max-length="16"
            v-decorator="['mobile', validatorRules.mobile]"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { jsonAction } from '@/api/manage';
import pick from 'lodash.pick';
import JDate from '@/components/jeecg/JDate';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
export default {
  data() {
    return {
      beforeValue: 'http://',
      afterValue: '.com',
      title: '修改网点信息',
      visible: false, //弹窗
      disabled: true, //编辑时产品姓名input框禁用
      // model:'year',
      model: {},
      typeText: '',
      name: '', //产品名称
      yearPick: null,
      yearPickShow: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      validatorRules: {
        web: {
          rules: [
            {
              required: true,
              message: '请输入正确的官网网址!',
              pattern:
                /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/,
            },
          ],
        },
        name: { rules: [{ required: true, message: '请输入网点名称!' }] },
        // sex: { rules: [{ required: true, message: '请选择性别!' }] },
        mobile: {
          rules: [
            {
              required: true,
              message: '请输入正确的网点电话!',
              pattern: '^[0-9]*$',
            },
          ],
        },
      },
      url: {
        // add: process.env.VUE_APP_CMS_PRODUCT + '/product/productsOrganization/add',
        edit: process.env.VUE_APP_CMS_PRODUCT + '/product/organization/save',
      },
    };
  },
  components: {
    JDate,
    JDictSelectTag,
  },
  methods: {
    addBeforeChange(val) {
      this.beforeValue = val;
    },
    addAfterChange(val) {
      this.afterValue = val;
    },
    edit(record) {
      record.fundcode = this.$route.query.fundCode;
      this.name = record.name;
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(this.model, 'id', 'web', 'name', 'mobile')
        );
      });
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    onChange() {},
    handleOk() {
      console.log(1);
      let that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          // let httpurl = '';
          // let method = '';
          // if (!this.model.cid) {
          //   httpurl += this.url.add;
          //   method = 'POST';
          // } else {
          //   httpurl += this.url.edit;
          //   method = 'POST';
          // }
          // let formData = Object.assign(this.model, values);
          values.id = this.model.id;
          console.log(this.model);
          values.web = this.beforeValue + values.web + this.afterValue;
          //时间格式化
          jsonAction(this.url.edit, values, 'POST').then((res) => {
            if (res.success) {
              that.$message.success(res.message);
              that.$emit('ok', that.model);
              that.confirmLoading = false;
              that.close();
            } else {
              that.$message.warning(res.message);
              that.confirmLoading = false;
            }
          });
        }
      });
    },
    handleCancel() {
      this.close();
    },
  },
};
</script>

<style scoped>
.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
